<template>
  <div>
    <el-card
      class="card-container"
      shadow="never"
    >
      <CardHeader
        slot="header"
        title="Danh sách tổ chức"
        :total="total"
        :size="'small'"
        :disabled="loading"
        @create="handleCreate"
        @refresh="handleRefresh"
      />
      <div>
        <CardFilter />
        <CardList
          :data="data"
          :loading="loading"
          @detail="handleDetail"
          @update="handleUpdate"
          @delete="handleDelete"
        />
        <el-row
          type="flex"
          align="middle"
          justify="end"
          class="mt-l"
        >
          <el-pagination
            background
            :current-page="page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="handleChangePageSize"
            @current-change="handleChangePage"
          />
        </el-row>
      </div>
      <DataFormPopup
        v-if="formVisible"
        :item="selectedItem"
        :visible="formVisible"
        @close="formVisible = false"
        @reload="listData"
      />
    </el-card>
  </div>
</template>

<script>
import CardFilter from "./components/CardFilter.vue";
import CardHeader from "./components/CardHeader.vue";
import CardList from "./components/CardList.vue";
import DataFormPopup from "./popups/DataForm.vue";

import { notification } from "@/utils/common";
import organizationServices from "@/services/organization";

export default {
  name: "Organizations",
  components: {
    CardHeader,
    CardFilter,
    CardList,
    DataFormPopup,
  },
  data() {
    return {
      loading: false,
      searchText: "",
      page: 1,
      pageSize: 10,
      total: 0,
      data: [],
      selectedItem: null,
      formVisible: false,
    };
  },
  computed: {
    params() {
      const _params = {
        q: this.searchText,
        offset: (this.page - 1) * this.pageSize,
        limit: this.page * this.pageSize,
        locale: "vi",
        sort: "-created"
      };
      return _params;
    },
  },
  beforeMount() {
    this.listData();
  },
  methods: {
    listData() {
      this.loading = true;
      organizationServices
        .list(this.params)
        .then((response) => {
          this.data = response.items.map((item, index) => ({
            ...item,
            stt: index + 1 + this.pageSize * (this.page - 1),
          }));
          this.total = response.meta.total;
          this.loading = false;
        })
        .catch(() => {
          this.data = [];
          this.loading = false;
        });
    },
    handleCreate() {
      this.selectedItem = null;
      this.formVisible = true;
    },
    handleDetail(item) {
      this.$router.push({
        name: "OrganizationDetail",
        params: { id: item.id },
      });
    },
    handleUpdate(item) {
      this.selectedItem = item;
      this.formVisible = true;
    },
    handleDelete(item) {
      this.$confirm(`Bạn có chắc chắn muốn xoá không?`, "Xác nhận", {
        confirmButtonText: "Xoá",
        cancelButtonText: "Huỷ",
        type: "warning",
      }).then(() => {
        organizationServices
          .remove(item)
          .then(() => {
            if (this.data.length === 1 && this.page > 1) {
              this.page = this.page - 1;
            }
            this.listData();
            notification(this, "success", "delete", "tổ chức");
          })
          .catch(() => {
            notification(this, "error", "delete", "tổ chức");
          });
      });
    },
    handleSearch() {
      this.page = 1;
      this.listData();
    },
    handleRefresh() {
      this.selectedItem = null;
      this.page = 1;
      this.searchText = "";
      this.listData();
    },
    handleChangePage(page) {
      this.page = page;
      this.listData();
    },
    handleChangePageSize(size) {
      this.page = 1;
      this.pageSize = size;
      this.listData();
    },
  },
};
</script>

<style lang="scss"></style>
